import {axiosService} from "../axios";

export const fileService = {

    fetchAllFiles: (page, size) => {
        return axiosService.get(`/api/files?page=${page - 1}&size=${size}`)
    },

    deleteFile: (fileId) => {
        return axiosService.delete(`/api/files/${fileId}`);
    },

    uploadFile: (file) => {

        const formData = new FormData();
        formData.append('file', file);

        return axiosService.post("/api/files/upload", formData);

    }

};
